import {getUserRole} from "./authentication";
import {UserRoles} from "./IAuthorization";
import {HubPathRouting} from "../HubFramework/pathBuilder";

export function isUserroleSufficient(target: UserRoles = UserRoles.reader, project: string = HubPathRouting.currentProject?.id, module: string = HubPathRouting.currentModule?.id) {
    //todo : test this
    const userRole = JSON.parse(getUserRole()) as {[scope: string]: UserRoles};

    let accepted = false
    // check global role
    const globalRole = userRole["user"] as keyof typeof UserRoles
    if (UserRoles[globalRole] >= target) {
        accepted = true

        // admin role is always sufficient
        if( UserRoles[globalRole] === UserRoles.admin) {
            return true
        }
    }

    // check project role
    if (project && userRole["user/" + project]) {
        const projectRole = userRole["user/" + project] as keyof typeof UserRoles
        accepted = UserRoles[projectRole] >= target
    }

    // check module role
    if (project && module && userRole["user/" + project + "/" + module]) {
        const moduleRole = userRole["user/" + project + "/" + module] as keyof typeof UserRoles
        accepted = UserRoles[moduleRole] >= target
    }

    // check if user has module rights on project level
    const transitiveRights = Object.keys(userRole).filter(x => x.startsWith("user/" + project + "/"))
    if (project && !module && transitiveRights.length > 0 && !userRole["user/" + project] && !userRole["user"]) {
        accepted = UserRoles.reader >= target
    }

    return accepted
}

export function isReaderRole() {
    return isUserroleSufficient(UserRoles.reader)
}

export function isEditorRole() {
    return isUserroleSufficient(UserRoles.editor)
}

export function isAdminRole() {
    return isUserroleSufficient(UserRoles.admin)
}